import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { RadialBarChart as RechartsRadialBarChart, RadialBar as RechartsRadialBar, Legend as RechartsLegend, PolarAngleAxis, Cell, Tooltip as RechartsTooltip, ResponsiveContainer, } from 'recharts';
import isFunction from 'lodash/fp/isFunction';
import { getColor, getFromDefaultColors, CURSOR_BACKGROUND_COLOR } from './chartHelper';
import Legend from './Legend';
const RadialBarChart = props => {
    const { width, height, data, dataKey, startAngle, endAngle, innerRadius, outerRadius, clockWise, legend, textOptions, radialBarOptions, showBarLabel, cornerRadius, background, range, tooltip } = props, remainingProps = __rest(props, ["width", "height", "data", "dataKey", "startAngle", "endAngle", "innerRadius", "outerRadius", "clockWise", "legend", "textOptions", "radialBarOptions", "showBarLabel", "cornerRadius", "background", "range", "tooltip"]);
    const _a = textOptions || {}, { text, size = '500%', weight = 'normal', color = 'gray-darkest' } = _a, remainingTextOptions = __rest(_a, ["text", "size", "weight", "color"]);
    const textStyle = {
        fontSize: size,
        fontWeight: weight,
        fill: color && getColor(color),
    };
    return (_jsx(ResponsiveContainer, Object.assign({ width: '100%', height: '100%' }, { children: _jsxs(RechartsRadialBarChart, Object.assign({ width: width, height: height, data: data, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle }, remainingProps, { children: [_jsx(RechartsRadialBar, Object.assign({ label: showBarLabel && { fill: '#666', position: 'insideStart' }, background: background, clockWise: clockWise, dataKey: dataKey, cornerRadius: cornerRadius }, radialBarOptions, { children: data.map((entry, index) => {
                        const cellColor = getColor(entry.color) || getFromDefaultColors(index);
                        return (_jsx(Cell, { fill: isFunction(color) ? color(entry, index) : cellColor }, `cell-${index}`));
                    }) })), range && _jsx(PolarAngleAxis, { type: 'number', domain: range, angleAxisId: 0, tick: false }), textOptions && (_jsx("text", Object.assign({ x: width / 2, y: height / 2, textAnchor: 'middle', dominantBaseline: 'middle', className: 'radialbarchart-text', style: textStyle }, remainingTextOptions, { children: text }))), legend && (_jsx(RechartsLegend, Object.assign({ formatter: (value, _) => _jsx("span", Object.assign({ className: 'text-color-darker' }, { children: value })) }, legend.props))), tooltip && _jsx(RechartsTooltip, Object.assign({ cursor: { fill: CURSOR_BACKGROUND_COLOR } }, tooltip.props))] })) })));
};
RadialBarChart.defaultProps = {
    width: 400,
    height: 200,
    data: [],
    dataKey: 'value',
    startAngle: 180,
    endAngle: 0,
    innerRadius: '30%',
    outerRadius: '100%',
    clockWise: true,
    legend: _jsx(Legend, {}),
    // textOptions,
    // radialBarOptions,
    showBarLabel: false,
    cornerRadius: 30,
    background: true,
    // range,
    tooltip: false,
};
export default RadialBarChart;
